module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_baloon--light-blue-59717c983b46794e6d11a532c3d224d9.svg";